import React from "react";
import { motion } from "framer-motion";

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-container">
            <motion.h2
                className="privacy-policy-heading"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                Privacy Policy
            </motion.h2>

            <motion.div
                className="privacy-policy-content"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
            >
                <p className="privacy-policy-paragraph">
                    At V9PrimeForce.com, your privacy is of paramount importance to us. This Privacy Policy outlines the types of information we collect, how we use it, and how we protect it. By using our website, you agree to the terms and practices described in this policy.
                </p>

                <h3>1. Information We Collect</h3>
                <p className="privacy-policy-paragraph">
                    We collect both personally identifiable information (PII) and non-personally identifiable information (non-PII). Personal data such as your name, email address, phone number, and payment information is collected when you register on the site or make a purchase. Non-PII includes your browsing activity, device information, and other related data that we collect through cookies and similar technologies.
                </p>

                <h3>2. How We Use Your Information</h3>
                <p className="privacy-policy-paragraph">
                    The information we collect is used to provide you with a better experience. It helps us personalize content, respond to inquiries, process transactions, and improve our website's performance. We may also use your information to send you updates, promotional offers, or newsletters if you've opted in.
                </p>

                <h3>3. Cookies and Tracking Technologies</h3>
                <p className="privacy-policy-paragraph">
                    Our website uses cookies and similar tracking technologies to enhance the user experience. Cookies allow us to remember your preferences and improve site functionality. You can choose to disable cookies through your browser settings, but this may limit your ability to access certain features of the site.
                </p>

                <h3>4. Sharing Your Information</h3>
                <p className="privacy-policy-paragraph">
                    We do not sell, rent, or trade your personal information to third parties. However, we may share your information with trusted service providers who help us operate our website or fulfill services on our behalf, such as payment processors and shipping companies. These providers are obligated to maintain the confidentiality of your information.
                </p>

                <h3>5. Data Security</h3>
                <p className="privacy-policy-paragraph">
                    We take the security of your personal information seriously and implement a variety of security measures to safeguard it. However, please note that no method of transmission over the Internet is 100% secure. While we strive to protect your information, we cannot guarantee its absolute security.
                </p>

                <h3>6. Your Rights</h3>
                <p className="privacy-policy-paragraph">
                    You have the right to access, update, or delete the personal information we hold about you. If you would like to exercise any of these rights, please contact us at the details provided below. Additionally, if you wish to opt-out of receiving marketing communications, you can unsubscribe using the link in our emails.
                </p>

                <h3>7. Changes to This Privacy Policy</h3>
                <p className="privacy-policy-paragraph">
                    We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the effective date of the updated policy will be indicated at the top of the page. We encourage you to review this Privacy Policy periodically to stay informed about how we are protecting your information.
                </p>

                <h3>8. Contact Us</h3>
                <p className="privacy-policy-paragraph">
                    If you have any questions or concerns about this Privacy Policy or the way we handle your personal information, please contact us at: <br />
                    Email: <a href="mailto:support@v9primeforce.com">support@v9primeforce.com</a>
                </p>
            </motion.div>
        </div>
    );
}

export default PrivacyPolicy;
